module.exports = __webpack_public_path__ + "static/media/Illustration_point3.25f4332a.svg";